import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IDemand } from 'src/app/shared/models/demand';
import { Echeance } from 'src/app/shared/models/echeance';
import { EcheancesService } from '../services/echeances.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EcheanceDetailsComponent } from '../echeance-details/echeance-details.component';
import { IPack } from 'src/app/shared/models/pack';
import { UserProfile } from 'src/app/shared/models/user-profile';
import { CommentPromptComponent } from '../dialog-box/comment-prompt.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { IApplication } from 'src/app/shared/models/application';
import { ApplicationProjectService } from 'src/app/core/application-project/services/application-project.service';
import { Constants } from 'src/app/shared/constants/Constants';
import { EcheanceStatus } from 'src/app/shared/models/echeance-status';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { IPrestation } from 'src/app/shared/models/prestation';
import { INettingPack } from 'src/app/shared/models/netting-pack';
import { NettingService } from 'src/app/core/netting-account/netting.service';
import { INetting } from 'src/app/shared/models/netting-account';
import { IManualData } from 'src/app/shared/models/manual-data';
import { DialogFormNettingService } from 'src/app/shared/dialog-form-netting/dialog-form-netting.service';
import { OrderFormService } from 'src/app/core/orders-forms/services/order-form.service';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { ApplicationSettingsService } from 'src/app/core/application-settings/application-settings.service';
import { CalendrierService } from 'src/app/core/calendrier-pack/calendrier.service';
import { ICalendrier } from 'src/app/shared/models/calendrier';
import { ApplicationSettings } from 'src/app/shared/models/application-settings';
import { DsiTypes, IDsi } from 'src/app/shared/models/dsi';
import { IUser } from 'src/app/shared/models/user';
import { UsersService } from 'src/app/core/user/services/users.service';
import { DomainesService } from 'src/app/core/domaines/domaines.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import * as fileSaver from 'file-saver';
import { JiraImportService } from 'src/app/core/import-data/jira-import/services/jira-import.service';
import { SnackbarService } from '../../../../shared/services/snackbar.service';

registerLocaleData(localeFr);

interface EcheanceMonthCellVm {
  index: number;
  isCurrentMonth: boolean;
  isEmpty: boolean;
  fusedEcheances: Echeance[];
  rawEcheances: Echeance[];
  redWarning: boolean;
}

interface DemandRowVm extends IDemand {
  demand: IDemand;
  demandNumber: string;
  currentDue: Echeance;
  historicSum: number;
  hasUnknownCommand: boolean;
  hasManualData: boolean;
  isOvershoot: boolean;
  canBeValidated: boolean;
  checkboxDisabled: boolean;
  monthCells: EcheanceMonthCellVm[];
  applicationShortName: string;
}

interface EcheancesSummaryVm {
  endMinusOne: number;
  end: number;
  ratio: number;
}

@Component({
  selector: 'app-echeances-list',
  templateUrl: './echeances-list.component.html',
  styleUrls: ['./echeances-list.component.less'],
})
export class EcheancesListComponent implements AfterViewInit {
  nettingAccounts: INetting[] = [];
  nettingsNames: string[] = [];
  public paginatorPageSize = 25;

  MONTHS: string[] = [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
  ];

  DISPLAYED_COLUMNS: string[] = [
    'checkboxColumn',
    'manualData',
    'orderNumber',
    'demandNumber',
    'demandDescription',
    'applicationName',
    'serviceType',
    'prestationType',
    'toBeFactured',
    'engaged',
    'status',
    'galLabel',
    'summary',
    'm1',
    'm2',
    'm3',
    'm4',
    'm5',
    'm6',
    'm7',
    'm8',
    'm9',
    'm10',
    'm11',
    'm12',
    'm13',
    'm14',
    'm15',
    'm16',
    'm17',
    'm18',
    'm19',
    'm20',
    'm21',
    'm22',
    'm23',
    'm24',
    'm25',
    'm26',
    'm27',
    'm28',
    'm29',
    'm30',
    'm31',
    'm32',
    'm33',
    'm34',
    'm35',
    'm36',
  ];

  dsis: IDsi[] = [];
  users: IUser[] = [];
  perimeterControl = new UntypedFormControl('');

  spinner = false;

  @ViewChild(MatSort)
  sort!: MatSort;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @Input()
  duesEvent!: boolean;

  @Input()
  refreshTable!: null;

  @Output()
  updateValidationCapability = new EventEmitter<boolean>();

  @Output()
  updateRejectionCapability = new EventEmitter<boolean>();

  @Output()
  setYear = new EventEmitter<string>();

  @Input()
  public enableValidation!: boolean;

  @Input()
  public enableRejection!: boolean;

  @Input()
  public areCalculationsDone!: boolean;

  @Input()
  public exportSpinner!: boolean;


  @Output()
  export = new EventEmitter<string>();

  //Valeurs de filtres
  public formValue = '';
  public filter = '';
  public filterValue = '';
  public reffilter = '';
  public reffilterValue = '';
  public galfilter = '';
  public galfilterValue = '';
  public desFilter = '';
  public desfilterValue = '';
  public searchIndex = 'search';
  public displayYears: number[] = [];
  public displayYearCDAFilterOptions: number[] = [];


  public displayDemandsStatus = new UntypedFormControl();
  public serviceFilter: string[] = [];
  public displayServiceFilter = new UntypedFormControl();
  displayYearCDAFilter = new FormControl();

  //Année courante
  public year: number = new Date().getFullYear();

  //Année/Mois de facturation
  public settingYear: boolean;
  public currMonthIndex = 0;

  //Objet mat-table
  public dataSource!: MatTableDataSource<IDemand>;

  //Demandes à afficher
  public demands: Map<string, IDemand> = new Map();

  //Objets mémoire
  public prestations: IPrestation[];
  public applications: IApplication[] = [];
  public orderForms: string[] = [];
  public currPack!: IPack;
  public DtOvershootMoreFivePercent: string[] = [];
  public applicationSettings: ApplicationSettings;
  public manualDataList: string[] = [];
  public manualData!: IManualData[];
  public netting!: INettingPack[];

  //Variables logiques (blocks, spinners)
  public totalCost: number[] = [];
  public lockValidation = false;
  public isAlreadyValidating = false;
  public isClosed = true;
  public asyncLock = true;
  public isTableLoading = false;
  public isFilterCDADesactivated = true;

  //Si en train de tout sélectionner
  public selectAll = false;

  //************* */ refacto en cours *************************

  public rows: DemandRowVm[] = [];
  public summary: EcheancesSummaryVm = {
    endMinusOne: 0,
    end: 0,
    ratio: 0,
  };

  private readonly ROWS_REFRESH_PART_DEMANDS = 1;
  private readonly ROWS_REFRESH_PART_MANUAL_DATA = 2;
  private readonly ROWS_REFRESH_PART_NETTING = 4;
  private readonly ROWS_REFRESH_PART_ALL =
    this.ROWS_REFRESH_PART_DEMANDS |
    this.ROWS_REFRESH_PART_MANUAL_DATA |
    this.ROWS_REFRESH_PART_NETTING;

  private rowsRefreshBatchId = 0;
  private rowsRefreshBatchMask = 0;

  public nettedDemandNumbers = new Set<string>();


  private startRowsRefreshBatch(): number {
    this.rowsRefreshBatchId += 1;
    this.rowsRefreshBatchMask = 0;
    return this.rowsRefreshBatchId;
  }

  private markRowsRefreshPartDone(batchId: number, part: number): void {
    if (batchId !== this.rowsRefreshBatchId) {
      return;
    }

    this.rowsRefreshBatchMask |= part;

    if (
      (this.rowsRefreshBatchMask & this.ROWS_REFRESH_PART_ALL) ===
      this.ROWS_REFRESH_PART_ALL
    ) {
      this.isTableLoading = false;
      this.refreshProjectedRows();
    }
  }

  private createEmptyTotalCost(): number[] {
    return Array.from({ length: 38 }, () => 0);
  }

  private resetTotalsAndSummary(): void {
    this.totalCost = this.createEmptyTotalCost();
    this.refreshProjectedSummary();
  }

  private finalizeDemandsLoad(batchId: number): void {
    this.markRowsRefreshPartDone(batchId, this.ROWS_REFRESH_PART_DEMANDS);
  }

  private applyDemandsResponse(
    data: { demands: IDemand[]; total: number } | null | undefined,
    debugMessage: string,
  ): void {
    if (!data) {
      this.resultsLength = 0;
      return;
    }

    if (this.debugModeActivated) {
      console.log(debugMessage);
      console.log(data);
    }

    data.demands.forEach((demand) => {
      this.echeancesService.checkIfDemandValidableARRejectable(demand);
      this.demands.set(demand.demandNumber, demand);
    });

    this.resultsLength = data.total;
  }

  private shouldTriggerFilterSearch(event: Event): boolean {
    const target = event.target as HTMLInputElement;
    return (event as KeyboardEvent).key === 'Enter' || target.value === '';
  }

  /**
   * Construit l'échéance courante affichée dans la colonne A facturer.
   * Agrège le mois courant du pack + les delayedCost.
   */
  private buildCurrentDue(demand: IDemand): Echeance {
    const ech = new Echeance();
    ech.cost = 0;
    ech.load = 0;

    let delayedCost = 0;

    for (const element of demand.echeances ?? []) {
      if (!element.date) {
        continue;
      }

      const date = new Date(element.date);

      if (element.delayedCost != null) {
        delayedCost += element.delayedCost;
      }

      if (
        date.getFullYear() === this.currPack.packYear &&
        date.getMonth() === this.currPack.packMonth - 1
      ) {
        ech.cost += element.cost;
        ech.load += element.load ?? 0;
        ech.status = element.status;
        ech.date = element.date;
      }
    }

    ech.cost += delayedCost;
    return ech;
  }

  /**
   * Calcule le total historique non projeté avant l'année de référence.
   * Sert à la colonne Total < année.
   */
  private buildHistoricSum(demand: IDemand): number {
    let total = 0;

    for (const ech of demand.echeances ?? []) {
      if (
        ech &&
        ech.date &&
        !ech.projected &&
        Number((ech.date + '').split('-')[0]) < this.year
      ) {
        total += ech.cost;
      }
    }

    return total;
  }

  /**
   * Détermine si la demande doit être marquée commande inconnue.
   * Utilisé pour les styles rouges sur montants/charges.
   */
  private buildHasUnknownCommand(demand: IDemand): boolean {
    if (
      demand.reference == null ||
      demand.reference === '' ||
      demand.reference.toUpperCase().includes('DEROGATION') ||
      demand.reference.toUpperCase().includes('SAUVEGARDE')
    ) {
      return true;
    }

    return this.orderForms.indexOf(demand.reference) === -1;
  }

  /**
   * Indique si la demande possède des données manuelles.
   * Utilisé pour afficher le marqueur + dans la colonne manualData.
   */
  private buildHasManualData(demand: IDemand): boolean {
    return (
      this.manualDataList.findIndex((value) => value === demand.demandNumber) !==
      -1
    );
  }

  /**
   * Indique si la demande est en dépassement selon la liste préchargée.
   */
  private buildIsOvershoot(demand: IDemand): boolean {
    if (!demand.reference) {
      return false;
    }

    return this.DtOvershootMoreFivePercent.includes(demand.reference);
  }

  /**
   * Pré-calcule les 36 cellules mensuelles de la ligne.
   * Fournit état vide, échéance fusionnée et indicateurs visuels pour le template.
   */
  private buildMonthCells(
    demand: IDemand,
    hasUnknownCommand: boolean,
  ): EcheanceMonthCellVm[] {
    const monthCells: EcheanceMonthCellVm[] = [];
    const rawEcheancesByMonthIndex = new Map<number, Echeance[]>();
    const baseYear = this.getYear();

    for (const echeance of demand.echeances ?? []) {
      if (!echeance?.date) {
        continue;
      }

      const date = new Date(echeance.date);
      const monthIndex = (date.getFullYear() - baseYear) * 12 + date.getMonth();

      if (monthIndex < 0 || monthIndex >= 36) {
        continue;
      }

      const bucket = rawEcheancesByMonthIndex.get(monthIndex);
      if (bucket) {
        bucket.push(echeance);
      } else {
        rawEcheancesByMonthIndex.set(monthIndex, [echeance]);
      }
    }

    const currentMonthOffset = this.currPack
      ? (this.currPack.packYear - baseYear) * 12 + (this.currPack.packMonth - 1)
      : -1;

    for (let index = 0; index < 36; index++) {
      const rawEcheances = rawEcheancesByMonthIndex.get(index) ?? [];

      const fused = new Echeance();
      fused.cost = 0;
      fused.load = 0;

      for (const echeance of rawEcheances) {
        fused.cost += echeance.cost;
        fused.load! += echeance.load ?? 0;
        fused.status = echeance.status;
        fused.projected = echeance.projected;
        fused.date = echeance.date;
      }

      const fusedEcheances = fused.cost !== 0 ? [fused] : [];

      monthCells.push({
        index,
        isCurrentMonth: index === currentMonthOffset,
        isEmpty: rawEcheances.length === 0,
        fusedEcheances,
        rawEcheances,
        redWarning: hasUnknownCommand,
      });
    }

    return monthCells;
  }

  /**
   * Encapsule la règle métier de validabilité pour la projection de ligne.
   */
  private buildCanBeValidated(demand: IDemand): boolean {
    return this.canBeValidated(demand);
  }

  /**
   * Construit le ViewModel complet d'une ligne de table à partir d'une demande.
   * Centralise les données déjà calculées pour éviter les appels coûteux en template.
   */
  private buildRowVm(demand: IDemand): DemandRowVm {
    const hasUnknownCommand = this.buildHasUnknownCommand(demand);
    const currentDue = this.buildCurrentDue(demand);
    const canBeValidated = this.buildCanBeValidated(demand);

    return {
      ...demand,
      demand,
      demandNumber: demand.demandNumber,
      currentDue,
      historicSum: this.buildHistoricSum(demand),
      hasUnknownCommand,
      hasManualData: this.buildHasManualData(demand),
      isOvershoot: this.buildIsOvershoot(demand),
      canBeValidated,
      checkboxDisabled:
        (!canBeValidated && !demand.rejectable) ||
        this.lockValidation ||
        currentDue.cost === 0,
      monthCells: this.buildMonthCells(demand, hasUnknownCommand),
      applicationShortName: (demand.applicationName ?? '').split('_')[0],
    };
  }

  /**
   * Reconstruit toutes les lignes projetées depuis la Map des demandes.
   * Appelé après chargement des demandes ou données annexes impactant l'affichage.
   */
  private rebuildRows(): void {
    this.rows = Array.from(this.demands.values()).map((demand) =>
      this.buildRowVm(demand),
    );
  }

  /**
   * Recalcule le bloc de synthèse en bas de page.
   * Dépend des totaux déjà chargés.
   */
  private rebuildSummary(): void {
    let endMinusOne = 0;

    for (let index = 0; index < this.currMonthIndex - 1; index++) {
      endMinusOne += this.totalCost[index] ?? 0;
    }

    const end =
      endMinusOne +
      (this.totalCost[this.currMonthIndex - 1] ?? 0) +
      (this.totalCost[37] ?? 0);
    const engaged = this.totalCost[36] ?? 0;

    this.summary = {
      endMinusOne,
      end: end === 0 ? 0 : end,
      ratio: engaged === 0 ? 0 : (100 * end) / engaged,
    };
  }

  /**
   * Point d'entrée de rafraîchissement des lignes projetées.
   * Ne fait rien tant que le pack courant n'est pas disponible.
   */
  private refreshProjectedRows(): void {
    if (!this.currPack) {
      return;
    }

    this.rebuildRows();
  }

  /**
   * Point d'entrée de rafraîchissement de la synthèse projetée.
   */
  private refreshProjectedSummary(): void {
    this.rebuildSummary();
  }

  public readonly monthIndexes = Array.from({ length: 36 }, (_, i) => i);

  public trackByDemandNumber = (_: number, row: DemandRowVm): string =>
    row.demandNumber;

  public trackByMonthIndex = (_: number, monthIndex: number): number =>
    monthIndex;

  public trackByEcheanceIdentity = (_: number, echeance: Echeance): string =>
    [
      echeance.date ?? '',
      echeance.status ?? '',
      echeance.projected ? '1' : '0',
      echeance.cost ?? 0,
      echeance.load ?? 0,
    ].join('|');

  public trackByName = (_: number, item: { name?: string } | string): string =>
    typeof item === 'string' ? item : item.name ?? '';

  public trackByDsi = (_: number, dsi: IDsi): string =>
    dsi.id ?? dsi.name ?? '';

  public trackByUser = (_: number, user: IUser): string =>
    user.id ?? user.identifier ?? user.email ?? `${user.lastName ?? ''}_${user.firstName ?? ''}`;

  public trackByApplication = (_: number, application: IApplication): string =>
    application.id ?? application.name ?? '';

  public trackByPrestation = (_: number, prestation: IPrestation): string =>
    prestation.name ?? '';

  public trackByString = (_: number, value: string): string =>
    value;

  public trackByNumber = (_: number, value: number): number =>
    value;

  public baseDisplayYear = new Date().getFullYear();
  public baseDisplayYearPlusOne = this.baseDisplayYear + 1;
  public baseDisplayYearPlusTwo = this.baseDisplayYear + 2;

  private refreshHeaderYears(): void {
    this.baseDisplayYear = this.getYear();
    this.baseDisplayYearPlusOne = this.baseDisplayYear + 1;
    this.baseDisplayYearPlusTwo = this.baseDisplayYear + 2;
  }
  // ***********************************************************
  //Constantes, enums
  demandStatus: string[] = [
    'Evalué',
    'Chiffré',
    'Approuvé',
    'Engagé',
    'Analysé',
    'En attente',
    'Implémenté',
    'Testé',
    'Abandonné',
    'Fermé',
    'Livré',
    'Réceptionné',
    'Accepté',
    'Mise en production',
    'Nouveau',
    'Ouvert',
    'Import Pack'
  ];

  //Année d'export
  public exportYear = 2021;

  //Affichage
  public isAppNamesNavVisible = true;
  public buttonTextFilter = 'Cacher';
  public resultsLength = 0;

  get Constants() {
    return Constants;
  }
  get Array() {
    return Array;
  }
  get EcheanceStatus() {
    return EcheanceStatus;
  }

  debugModeActivated = false;
  centreCompetenceMode = false;

  constructor(
    public echeancesService: EcheancesService,
    private cdref: ChangeDetectorRef,
    private applicationProjectService: ApplicationProjectService,
    private dialog: MatDialog,
    private snackbarService: SnackbarService,
    public authenticationService: AuthenticationService,
    private _nettingService: NettingService,
    private _dfns: DialogFormNettingService,
    private _ofs: OrderFormService,
    public _as: ApplicationSettingsService,
    private _cs: CalendrierService,
    private _us: UsersService,
    public theme: ThemeService,
    private _ds: DomainesService,
    private _es: EcheancesService,
    private jiraImportService: JiraImportService,
  ) {
    this.paginatorPageSize = this.paginatorNumberFromProfile();
    this.debugModeActivated = this.authenticationService.getDebugMode();
    this.centreCompetenceMode = this._as.applicationSettings.Enable_Centre_Service;

    this.year = this._as.getApplicationSettings().Pack_current_year;
    this.totalCost = this.createEmptyTotalCost();

    this.displayYearCDAFilterOptions = [this.year, this.year - 1, this.year - 2];

    this.prestations = [];
    this.applicationSettings = _as.getApplicationSettings();
    this.settingYear = this.applicationSettings.Enable_Previous_Year;

    if (!this.applicationSettings.display_fusion_pack && this.settingYear) this.displayYears.push(this.year - 1);
    this.displayYears.push(this.year);
    this.refreshHeaderYears();

    this.echeancesService.getLatestPack().subscribe({
      next: value => {
        this.currPack = new IPack();
        this.currPack.packMonth = value.packMonth;
        this.currPack.packYear = value.packYear;
        this.exportYear = value.packYear;
        this.currPack.packCommandYear = value.packCommandYear;
        this.currMonthIndex = this.currPack.packMonth + ((this.currPack.packYear - this.getYear()) * 12);

        this.year = this.applicationSettings.Pack_current_year;
        this.initMiscData();
        this.updatePerimeterOptions();
        this.getApplicationsNamesThenRelatedDemands();
      },
      error: err => {
        console.log(err);
      },
      complete: () => {
        this.initValidationCalendarWorkflow();
      }
    });

  }

  ngAfterViewInit() {
    this.echeancesService.getPrestations().subscribe({
      next: value => {
        for (const element of value) {
          const prestation: IPrestation = { name: element, selected: false };
          this.prestations.push(prestation);
        }
      },
      error: err => {
        console.log(err);
      }
    });

    this.cdref.detectChanges();
  }

  paginatorNumberFromProfile() {
    if (this.authenticationService.getUser().profile == UserProfile.ADMIN) {
      return 100;
    }
    else {
      return 25;
    }
  }


  /**
  * Initialisation: Rafraichit les données manuelles en mémoire.
  */
  updateManualData(batchId?: number) {
    const demandNumbers = Array.from(this.demands.keys());
    this.manualDataList = [];

    if (!demandNumbers.length) {
      if (batchId != null) {
        this.markRowsRefreshPartDone(batchId, this.ROWS_REFRESH_PART_MANUAL_DATA);
      } else {
        this.refreshProjectedRows();
      }
      return;
    }

    this.echeancesService.getManualDataDemandNumbers(demandNumbers).subscribe({
      next: (value) => {
        this.manualDataList = value ?? [];

        if (batchId != null) {
          this.markRowsRefreshPartDone(batchId, this.ROWS_REFRESH_PART_MANUAL_DATA);
        } else {
          this.refreshProjectedRows();
        }
      },
      error: (err) => {
        console.log(err);
        if (batchId != null) {
          this.markRowsRefreshPartDone(batchId, this.ROWS_REFRESH_PART_MANUAL_DATA);
        }
      }
    });
  }

  /**
  * Initialisation: Initialise les données mémoires non vitales au premier appel (services, dépassements, nettings, prestation).
  */
  initMiscData() {
    this._nettingService.getNettingAccountHasProject().subscribe({
      next: (data) => {
        if (data) {
          this.nettingsNames = data;
        }
      },
      error: (err) => {
        console.log(err);
      }
    });

    this._ofs.getOrdersForms().subscribe({
      next: (value) => {
        for (const element of value) this.orderForms.push(element.number);
        this.refreshProjectedRows();
      },
      error: (err) => {
        console.log(err);
      }
    }
    );

    //All DT with overshoot of more than 5%
    this.echeancesService
      .getDTWithOvershootOfMoreFivePercent()
      .subscribe({
        next: data => {
          this.DtOvershootMoreFivePercent = data;
          this.refreshProjectedRows();
        },
        error: err => {
          console.log(err);
        }
      });


    this.echeancesService.getAllServices()
      .subscribe({
        next: data => {
          this.serviceFilter = data.sort();
        },
        error: err => {
          console.log(err);
        }
      });
  }

  /**
 * Initialisation: Rassemble les filtres, récupère une liste de demande et s'il est en première page de tableau, recalcule les totaux.
 */
  getFilteredAndPagedDemandsAndTotals() {
    this.refreshHeaderYears();

    const years =
      this.displayYears[0] == null ? [this.year] : [...this.displayYears];
    const dateForCDAFilter = this.displayYearCDAFilter.value;
    const demandStatus =
      this.displayDemandsStatus.value == null ||
        this.displayDemandsStatus.value.length === 0
        ? []
        : this.displayDemandsStatus.value;
    const statusFilter =
      this.displayServiceFilter.value == null ||
        this.displayServiceFilter.value.length === 0
        ? []
        : this.displayServiceFilter.value;

    this.setYear.emit(this.getYear() + '');

    const applicationsNames = this.getSelectedApplicationsNames();
    const prestationNames = this.getSelectedPrestationTypes();

    this.isTableLoading = true;
    this.demands.clear();
    const rowsRefreshBatchId = this.startRowsRefreshBatch();

    this.echeancesService
      .getPaginatedDemands(
        this.paginator.pageIndex,
        this.paginator.pageSize,
        this.sort.direction,
        this.filter.toUpperCase(),
        this.reffilter.toUpperCase(),
        this.galfilterValue.toUpperCase(),
        this.desfilterValue,
        years,
        applicationsNames,
        prestationNames,
        this.searchIndex,
        this.authenticationService.getUser().profile + '',
        demandStatus,
        statusFilter,
        dateForCDAFilter,
      )
      .subscribe({
        next: (data: { demands: IDemand[]; total: number }) => {
          this.applyDemandsResponse(
            data,
            '[DT] Toutes les demandes avec application des filtres',
          );
          this.updateManualData(rowsRefreshBatchId);
          this.finalizeDemandsLoad(rowsRefreshBatchId);
        },
        error: (err) => {
          console.log(err);
          this.markRowsRefreshPartDone(rowsRefreshBatchId, this.ROWS_REFRESH_PART_MANUAL_DATA);
          this.finalizeDemandsLoad(rowsRefreshBatchId);
        },
      });

    this.updateNettingData(rowsRefreshBatchId);

    if (this.paginator.pageIndex == 0) {
      this.resetTotalsAndSummary();

      this.echeancesService
        .getDueTotal(
          this.filter.toUpperCase(),
          this.reffilter.toUpperCase(),
          this.galfilterValue.toUpperCase(),
          this.desfilterValue,
          years,
          applicationsNames,
          prestationNames,
          this.searchIndex,
          this.authenticationService.getUser().profile + '',
          demandStatus,
          statusFilter,
          dateForCDAFilter,
        )
        .subscribe({
          next: (value) => {
            this.totalCost = value;
            this.refreshProjectedSummary();
          },
          error: (err) => {
            console.log(err);
          },
        });
    }
  }

  //Variante simplifiée ignorant les filtres (pour le premier appel).
  getInitialDemandsAndTotals() {
    this.refreshHeaderYears();

    const rowsRefreshBatchId = this.startRowsRefreshBatch();
    const years =
      this.displayYears[0] == null ? [this.year] : [...this.displayYears];

    this.setYear.emit(this.getYear() + '');

    const applicationsNames = this.getSelectedApplicationsNames();

    this.isTableLoading = true;

    this.echeancesService
      .getPaginatedDemands(
        0,
        100,
        'null',
        'null',
        'null',
        'null',
        'null',
        years,
        applicationsNames,
        [],
        this.searchIndex,
        this.authenticationService.getUser().profile + '',
        [],
        [],
        0,
      )
      .subscribe({
        next: (data: { demands: IDemand[]; total: number }) => {
          this.applyDemandsResponse(
            data,
            '[DT] Toutes les demandes lors du premier appel sans application des filtres',
          ); this.updateManualData(rowsRefreshBatchId);
          this.initValidationCalendarWorkflow();
          this.finalizeDemandsLoad(rowsRefreshBatchId);
        },
        error: (err) => {
          console.log(err);
          this.markRowsRefreshPartDone(rowsRefreshBatchId, this.ROWS_REFRESH_PART_MANUAL_DATA);
          this.finalizeDemandsLoad(rowsRefreshBatchId);
        },
      });

    this.updateNettingData(rowsRefreshBatchId);

    if (this.paginator.pageIndex == 0) {
      this.resetTotalsAndSummary();

      this.echeancesService
        .getDueTotal(
          'null',
          'null',
          'null',
          'null',
          years,
          applicationsNames,
          [],
          this.searchIndex,
          this.authenticationService.getUser().profile + '',
          [],
          [],
          0,
        )
        .subscribe({
          next: (value) => {
            this.totalCost = value;
            this.refreshProjectedSummary();
          },
          error: (err) => {
            console.log(err);
          },
        });
    }
  }

  /**
  * Initialisation: Récupère les affectations des nettings
  */
  updateNettingData(batchId?: number) {
    this._dfns.getNettedDemandNumbers().subscribe({
      next: (value) => {
        this.nettedDemandNumbers = new Set(value ?? []);

        if (batchId != null) {
          this.markRowsRefreshPartDone(batchId, this.ROWS_REFRESH_PART_NETTING);
        } else {
          this.refreshProjectedRows();
        }
      },
      error: (err) => {
        console.log(err);
        if (batchId != null) {
          this.markRowsRefreshPartDone(batchId, this.ROWS_REFRESH_PART_NETTING);
        }
      }
    });
  }

  /**
  * Initialisation: Importe les données de calendrier et définit les autorisations de validation.
  */
  initValidationCalendarWorkflow() {
    this._cs.getCalendrier().subscribe({
      next: value => {
        const cals: ICalendrier[] = value;
        let cal: ICalendrier = cals[0];
        for (const element of cals) {
          if (
            element.month == this._as.applicationSettings.Pack_current_month &&
            element.year == this._as.applicationSettings.Pack_current_year
          )
            cal = element;
        }

        this.lockValidation = false;

        const dateComp: Date = new Date(Date.now());
        cal.valid_debut = new Date(Date.parse(cal.valid_debut + ''));
        cal.ouverture = new Date(Date.parse(cal.ouverture + ''));
        cal.valid_fin = new Date(Date.parse(cal.valid_fin + ''));
        cal.valid_fin.setHours(23);
        cal.valid_fin.setMinutes(59);
        cal.initialisation = new Date(Date.parse(cal.initialisation + ''));
        // si date comp est compris entre la date d'ouverture et de fin de validation, on passe isFilterCDADesactivated à false
        if (cal.ouverture.getTime() <= dateComp.getTime() && cal.valid_fin.getTime() >= dateComp.getTime()) {
          this.isFilterCDADesactivated = false;
        }

        if (this.debugModeActivated) {
          console.log("******** Mode débogage actif ********");
          console.log("[VALIDATION] Calendrier : ", cal);
          console.log("[VALIDATION] Date du jour (dateComp):", dateComp);
          console.log("[VALIDATION] cal.valid_fin.getTime() < dateComp.getTime() || cal.valid_debut.getTime() > dateComp.getTime()", cal.valid_fin.getTime() < dateComp.getTime() || cal.valid_debut.getTime() > dateComp.getTime())
          console.log("[VALIDATION] cal.valid_fin.getTime() < dateComp.getTime() || cal.ouverture.getTime() > dateComp.getTime()", cal.valid_fin.getTime() < dateComp.getTime() || cal.ouverture.getTime() > dateComp.getTime())
        }
        this.isClosed = cal.cloture != null && cal.cloture != undefined;
        if (
          (this.authenticationService.getUser().profile == UserProfile.CP_SNCF ||
            this.authenticationService.getUser().profile ==
            UserProfile.SERVICE_MANAGER) &&
          (!this.applicationSettings.Enable_SNCF_Validation ||
            cal.valid_fin.getTime() < dateComp.getTime() ||
            cal.valid_debut.getTime() > dateComp.getTime())
        ) {
          this.lockValidation = true;
        }

        if (
          this.authenticationService.getUser().profile == UserProfile.GUEST_CDS ||
          this.authenticationService.getUser().profile == UserProfile.GUEST_SNCF
        )
          this.lockValidation = true;


        if (
          (this.authenticationService.getUser().profile == UserProfile.CP_CDS ||
            this.authenticationService.getUser().profile ==
            UserProfile.MANAGER_CDS) &&
          (cal.valid_fin.getTime() < dateComp.getTime() ||
            cal.ouverture.getTime() > dateComp.getTime())
        ) {
          this.lockValidation = true;
        }

        this.refreshProjectedRows();
      },
      error: err => {
        console.log(err);
      },
      complete: () => {
        if (this.debugModeActivated) {
          Promise.all([
            this.getLockValidationForProfile(UserProfile.CP_CDS),
            this.getLockValidationForProfile(UserProfile.CP_SNCF),
            this.getLockValidationForProfile(UserProfile.GUEST_SNCF),
            this.getLockValidationForProfile(UserProfile.GUEST_CDS),
            this.getLockValidationForProfile(UserProfile.MANAGER_CDS),
            this.getLockValidationForProfile(UserProfile.SERVICE_MANAGER),

          ]).then(results => {
            console.log("[VALIDATION] Etat de lockValidation pour le profil CDS :", results[0]);
            console.log("[VALIDATION] Etat de lockValidation pour le profil SNCF :", results[1]);
            console.log("[VALIDATION] Etat de lockValidation pour le profil GUEST_SNCF :", results[2]);
            console.log("[VALIDATION] Etat de lockValidation pour le profil GUEST_CDS :", results[3]);
            console.log("[VALIDATION] Etat de lockValidation pour le profil MANAGER_CDS :", results[4]);
            console.log("[VALIDATION] Etat de lockValidation pour le profil SERVICE_MANAGER :", results[5]);
            console.log("[VALIDATION] Etat de lockvalidation pour l'utilisateur actuel:", this.lockValidation)
          }).catch(err => {
            console.log(err);
          });
        }
      }
    }
    );

  }

  /**
   * Utiliser uniquement pour le debug quand on est connecter en admin
   */
  getLockValidationForProfile(profile: UserProfile): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this._cs.getCalendrier().subscribe({
        next: value => {
          const cals: ICalendrier[] = value;
          let cal: ICalendrier = cals[0];
          for (const element of cals) {
            if (
              element.month == this._as.applicationSettings.Pack_current_month &&
              element.year == this._as.applicationSettings.Pack_current_year
            )
              cal = element;
          }

          const dateComp: Date = new Date(Date.now());
          cal.valid_debut = new Date(Date.parse(cal.valid_debut + ''));
          cal.ouverture = new Date(Date.parse(cal.ouverture + ''));
          cal.valid_fin = new Date(Date.parse(cal.valid_fin + ''));
          cal.valid_fin.setHours(23);
          cal.valid_fin.setMinutes(59);
          cal.initialisation = new Date(Date.parse(cal.initialisation + ''));

          let lockValidation = false;

          if (
            (profile == UserProfile.CP_SNCF ||
              profile == UserProfile.SERVICE_MANAGER) &&
            (!this.applicationSettings.Enable_SNCF_Validation ||
              cal.valid_fin.getTime() < dateComp.getTime() ||
              cal.valid_debut.getTime() > dateComp.getTime())
          ) {
            lockValidation = true;
          }

          if (
            (profile == UserProfile.CP_CDS ||
              profile == UserProfile.MANAGER_CDS) &&
            (cal.valid_fin.getTime() < dateComp.getTime() ||
              cal.ouverture.getTime() > dateComp.getTime())
          ) {
            lockValidation = true;
          }

          if (
            profile == UserProfile.GUEST_CDS ||
            profile == UserProfile.GUEST_SNCF
          ) {
            lockValidation = true;
          }

          resolve(lockValidation);
        },
        error: err => {
          console.log(err);
          reject(new Error("Une erreur est survenue"));
        }
      });
    });
  }


  /**
   * Initialisation: Récupérer la liste exhaustive des noms d'applications, puis les demandes relatives au applications sélectionnées
   */
  getApplicationsNamesThenRelatedDemands(): void {
    this.applicationProjectService.getApplicationsNames().subscribe({
      next: (applicationsNames) => {
        let filtredApplicationsNames: string[] = [];

        if (
          this.authenticationService.getUser() &&
          (this.authenticationService.getUser().profile ==
            UserProfile.CP_SNCF ||
            this.authenticationService.getUser().profile == UserProfile.CP_CDS)
        ) {
          filtredApplicationsNames = applicationsNames.filter((element) => {
            return (
              this.authenticationService.getUser().applications &&
              this.authenticationService
                .getUser()
                .applications.filter((e) => e.name === element).length > 0
            );
          });
        } else {
          filtredApplicationsNames = applicationsNames;
        }

        if (
          this.perimeterControl.value != undefined &&
          this.perimeterControl.value != '' &&
          this.perimeterControl.value != null &&
          this.perimeterControl.value.applications != null
        ) {
          const apps: IApplication[] = this.perimeterControl.value.applications;
          filtredApplicationsNames = applicationsNames.filter((element) => {
            return apps.filter((e) => e.name === element).length > 0;
          });
        }

        this.applications = filtredApplicationsNames.map<IApplication>(
          (element) => {
            return { name: element, selected: false };
          },
        );
        if (this.orderForms.length == 0 && this.nettingsNames.length == 0) {
          this.getInitialDemandsAndTotals();
        } else {
          this.getFilteredAndPagedDemandsAndTotals();
        }

        this.paginator.pageIndex = 0;
      },
      error: (err) => {
        console.log(err);
      }
    });
  }


  /**
  * Filtres: Détermine les noms des applications cochées
  */
  getSelectedApplicationsNames(): string[] {
    let applicationsNames: string[] = this.applications
      .filter((element) => {
        return element.selected;
      })
      .map((element) => {
        return element.name as string;
      });

    if (
      !applicationsNames.length &&
      this.authenticationService.getUser() &&
      (this.authenticationService.getUser().profile == UserProfile.CP_SNCF ||
        this.authenticationService.getUser().profile == UserProfile.CP_CDS ||
        this.perimeterControl.value != null)
    ) {
      // dans le cas d'un profil CP SNCF, et que aucune application n'a été sélectionné, on prend les applications associées au profil

      applicationsNames = this.applications.map(
        (element) => element.name as string,
      );
    }

    return applicationsNames;
  }

  /**
   * Filtres: Détermine les noms des prestations cochées
   */
  getSelectedPrestationTypes(): string[] {
    const presNames: string[] = this.prestations
      .filter((element) => {
        return element.selected;
      })
      .map((element) => {
        return '*' + element.name;
      });
    return presNames;
  }

  /**
   * Filtres: Events lors de la modification de la valeur du filtre, met à jour la valeur puis relance une recherche de demande
   */
  filterList(event: Event) {
    this.filter = (event.target as HTMLInputElement).value;
    if (this.shouldTriggerFilterSearch(event)) {
      this.getFilteredAndPagedDemandsAndTotals();
      this.paginator.pageIndex = 0;
    }
  }

  reffilterList(event: Event) {
    this.reffilter = (event.target as HTMLInputElement).value;
    if (this.shouldTriggerFilterSearch(event)) {
      this.getFilteredAndPagedDemandsAndTotals();
      this.paginator.pageIndex = 0;
    }
  }

  galfilterList(event: Event) {
    this.galfilter = (event.target as HTMLInputElement).value;
    if (this.shouldTriggerFilterSearch(event)) {
      this.getFilteredAndPagedDemandsAndTotals();
      this.paginator.pageIndex = 0;
    }
  }

  desfilterList(event: Event) {
    this.desFilter = (event.target as HTMLInputElement).value;
    if (this.shouldTriggerFilterSearch(event)) {
      this.getFilteredAndPagedDemandsAndTotals();
      this.paginator.pageIndex = 0;
    }
  }

  /**
  * Filtres: Change le mode de recherche. Appelé à 'search' lors de la réinitialisation des filtres
  */
  updateApplicationFilter(index: string) {
    if (index != '') this.searchIndex = index;
    this.paginator.pageIndex = 0;
    this.refreshHeaderYears();
    this.getFilteredAndPagedDemandsAndTotals();
  }

  /**
  * Filtres: Réinitialise tous les filtres
  */
  disableApplicationFilter() {
    this.filterValue = '';
    this.reffilterValue = '';
    this.filter = '';
    this.reffilter = '';
    this.galfilterValue = '';
    this.desFilter = '';
    this.desfilterValue = '';
    this.applications.forEach((element) => {
      element.selected = false;
    });
    this.prestations.forEach((element) => {
      element.selected = false;
    });
    this.updateApplicationFilter('');
  }

  /**
  * Filtres: Event lors d'une sélection d'un périmètre applicatif: redétermine les applications disponibles
  */
  onPerimeterChange() {

    if (this.perimeterControl.value == null)
      this.getApplicationsNamesThenRelatedDemands();
    else if (this.perimeterControl.value.type == null)
      this.getApplicationsNamesThenRelatedDemands();
    else
      this.applicationProjectService
        .getApplicationsByDsi(this.perimeterControl.value.id)
        .subscribe({
          next: data => {
            this.perimeterControl.value.applications = data;
            this.getApplicationsNamesThenRelatedDemands();
          },
          error: err => {
            console.log(err);
          }
        });
  }

  /**
   * Filtres: Récupère l'année à résumer selon le contexte et le filtre
   */
  getYear(): number {
    if (this.displayYears[0] == null) return this.year;
    return this.displayYears[0];
  }



  /**
  * Périmètres: Initialise la sélection des périmètres
  */
  updatePerimeterOptions() {
    this._us.getAllContacts().subscribe({
      next: data => {
        data.forEach((user) => {
          if (user.applications!.length > 0)
            switch (
            this.getProfileProvenance(
              this.authenticationService.getUser().profile!,
            )
            ) {
              case 'neither':
                this.users.push(user);
                break;
              case 'CDS':
                break;
            }
        });
        this.users.sort((a, b) => a.lastName!.localeCompare(b.lastName!));
      },
      error: err => {
        console.log(err);
      }
    });
    this._ds.getDsisLight().subscribe({
      next: data => {
        data.forEach((dsi) => {
          switch (
          this.getProfileProvenance(
            this.authenticationService.getUser().profile!,
          )
          ) {
            case 'neither':
            case 'CDS':
              this.dsis.push(dsi);
              break;
            case 'SNCF':
              if (
                dsi.type == DsiTypes.DirectionMetier ||
                dsi.type == DsiTypes.DSI ||
                dsi.type == DsiTypes.DDSI
              )
                this.dsis.push(dsi);
              break;
          }
        });
      },
      error: err => {
        console.log(err);
      }
    });
  }

  /**
  * Périmètres: Retourne true si l'utilisateur est Invité CDS ou SNCF
  */
  isGuest(): boolean {
    switch (this.authenticationService.getUser().profile) {
      case UserProfile.GUEST_CDS:
      case UserProfile.GUEST_SNCF:
        return true;
      default:
        return false;
    }
  }

  /**
  * Périmètres: Retourne si l'utilisateur a un profil CDS ou SNCF
  */
  getProfileProvenance(profile: UserProfile): string {
    switch (profile) {
      case UserProfile.CP_CDS:
      case UserProfile.GUEST_CDS:
      case UserProfile.MANAGER_CDS:
        return 'CDS';

      case UserProfile.CP_SNCF:
      case UserProfile.GUEST_SNCF:
      case UserProfile.SERVICE_MANAGER:
        return 'SNCF';
    }
    return 'neither';
  }



  /**
  * Détails de demande:  Clic sur une des lignes de la liste des demandes: Ouvre la popup des détails de la demande
  */
  openDemandDetails(row: IDemand) {
    const arr = Array.from(this.demands.values());
    const index = arr.findIndex(d => d.demandNumber === row.demandNumber);

    console.log("centre de service : ", this._as.getApplicationSettings().Enable_Centre_Service)
    console.log("Demande sélectionnée : ", row);
    console.log("data envoyée à la popup : ", {
      data: arr,
      index,
      validatable: !this.lockValidation,
      min: 0,
      max: arr.length - 1,
      month: this.currPack.packMonth,
      year: this.currPack.packYear
    });

    const dialogRef = this.dialog.open(EcheanceDetailsComponent, {
      data: {
        data: arr,
        index,
        validatable: !this.lockValidation,
        min: 0,
        max: arr.length - 1,
        month: this.currPack.packMonth,
        year: this.currPack.packYear,
        centreCompetenceMode: this.centreCompetenceMode
      }
    });



    const sub = dialogRef.componentInstance.refreshTable.subscribe({
      next: () => { this.getFilteredAndPagedDemandsAndTotals(); },
      error: (err: any) => { console.log(err); }
    });
    dialogRef.afterClosed().subscribe(() => sub.unsubscribe());
  }

  /**
  * Détails de demande: Détermine l'index de la ligne correspondant à une demande donnée
  */
  getIndexFromDemand(row: IDemand): number {
    const arr = Array.from(this.demands.values());
    return arr.findIndex(d => d.demandNumber === row.demandNumber);
  }



  /**
   * Validation de groupe: Valider les écheances des demandes séléctionnées
   */
  public validateDemands() {
    this.isAlreadyValidating = true;

    const selectedDemandsNumbers = Array.from(this.demands.values())
      .filter((demand) => demand.selected)
      .map((demand) => demand.demandNumber);

    if (!selectedDemandsNumbers.length) {
      this.isAlreadyValidating = false;
      return;
    }

    this.echeancesService.validateDemands(selectedDemandsNumbers).subscribe({
      next: (data) => {
        if (data?.error) {
          console.error(data.error);

          if (data.demandsNumbersInError) {
            this.openErrorSnackBar(
              Constants.ErrorMessages.DEMANDS_NOT_VALIDATED +
              data.demandsNumbersInError,
            );
          } else {
            this.openErrorSnackBar(Constants.ErrorMessages.SERVER_TECH_ERROR);
          }

          if (data.updatedDemands?.length) {
            this.synchronizeUpdatedDemandsStatuses(data);
            this.updateDemandsValidationAndRejectionCapabilities();
            this.isAlreadyValidating = false;
          }
        } else if (data.updatedDemands?.length) {
          this.openSuccessSnackBar(Constants.Messages.DEMANDS_VALIDATED);
          this.synchronizeUpdatedDemandsStatuses(data);
          this.updateDemandsValidationAndRejectionCapabilities();
          this.isAlreadyValidating = false;
        }

        this.asyncLock = true;
      },
      error: (err) => {
        console.error(err);
        this.isAlreadyValidating = false;
      },
    });
  }
  /**
   * Validation de groupe: Refuser les écheances des demandes séléctionnées
   */
  public rejectDemands() {
    this.isAlreadyValidating = true;

    const selectedDemandsNumbers = Array.from(this.demands.values())
      .filter((demand) => demand.selected)
      .map((demand) => demand.demandNumber);

    if (!selectedDemandsNumbers.length) {
      this.isAlreadyValidating = false;
      return;
    }

    this.openCommentPrompt()
      .afterClosed()
      .subscribe({
        next: (comment) => {
          if (comment) {
            const reasonOfRejection = 'Motif du rejet : ' + comment;

            this.echeancesService
              .rejectDemands(selectedDemandsNumbers, reasonOfRejection)
              .subscribe({
                next: (data) => {
                  if (data?.error) {
                    console.error(data.error);

                    if (data.demandsNumbersInError) {
                      this.openErrorSnackBar(
                        Constants.ErrorMessages.DEMANDS_NOT_REJECTED +
                        data.demandsNumbersInError,
                      );
                    } else {
                      this.openErrorSnackBar(
                        Constants.ErrorMessages.SERVER_TECH_ERROR,
                      );
                    }

                    if (data.updatedDemands?.length) {
                      this.synchronizeUpdatedDemandsStatuses(data);
                      this.updateDemandsValidationAndRejectionCapabilities();
                      this.isAlreadyValidating = false;
                    }
                  } else if (data.updatedDemands?.length) {
                    this.openSuccessSnackBar(
                      Constants.Messages.DEMANDS_REJECTED,
                    );
                    this.synchronizeUpdatedDemandsStatuses(data);
                    this.updateDemandsValidationAndRejectionCapabilities();
                    this.isAlreadyValidating = false;
                  }
                },
                error: (err) => {
                  console.error(err);
                  this.isAlreadyValidating = false;
                },
              });
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  /**
  * Validation de groupe: Met à jour les échéances et la capacité à valider de toutes les demandes affectée par une validation/refus de groupe.
  */
  public synchronizeUpdatedDemandsStatuses(data: any) {
    data.updatedDemands.forEach((updatedDemand: IDemand) => {
      const foundDemand = this.demands.get(updatedDemand.demandNumber);
      if (foundDemand?.echeances && updatedDemand.echeances) {
        foundDemand.echeances = updatedDemand.echeances;
        this.echeancesService.checkIfDemandValidableARRejectable(foundDemand);
      }
    });
  }

  /**
  * Validation de groupe: Cocher toutes les demandes disponibles
  */
  public selectAllDemands() {
    this.rows
      .filter((row) => {
        return (
          row.currentDue.cost !== 0 &&
          (row.canBeValidated || row.demand.rejectable)
        );
      })
      .forEach((row) => {
        row.demand.selected = this.selectAll;
        row.selected = this.selectAll;
      });

    this.updateDemandsValidationAndRejectionCapabilities();
  }

  /**
  * Validation de groupe: Rafraichit les coches de chaque demande selon le statut d'échéance et le netting.
  */
  public updateDemandsValidationAndRejectionCapabilities() {
    const validableDemands = this.rows.filter((row) => {
      return row.canBeValidated && row.demand.selected;
    });
    this.updateValidationCapability.emit(!!validableDemands.length);

    const rejectableDemands = this.rows.filter((row) => {
      return row.demand.rejectable && row.demand.selected;
    });
    this.updateRejectionCapability.emit(!!rejectableDemands.length);
  }

  /**
  * Validation de groupe: Détermine si une demande peut être validée selon le contexte
  */
  // canBeValidated
  public canBeValidated(d: IDemand): boolean {
    if (d.serviceType == "A renseigner") return false;
    if (!d.validable) return false;

    if (
      !this.authenticationService.isUserAdmin() &&
      this.authenticationService.getUser().profile != UserProfile.CP_SNCF &&
      this.authenticationService.getUser().profile != UserProfile.SERVICE_MANAGER
    ) {
      return this.nettedDemandNumbers.has(d.demandNumber);
    }

    return true;
  }

  /**
  * Validation de groupe: Ouvre une fenêtre de commentaire lorsque refuse des demandes
  */
  openCommentPrompt(): MatDialogRef<CommentPromptComponent, any> {
    return this.dialog.open(CommentPromptComponent, {});
  }



  /**
  * Montants: Calcul du montant total Constaté fin M-1
  */
  public getEndMinusOne(): number {
    let res = 0;
    for (let i = 0; i < this.currMonthIndex - 1; i++)
      res += this.totalCost[i];
    return res;
  }

  /**
  * Montants: Calcul du montant total Constaté fin M
  */
  public getEnd(): number {
    let res = this.getEndMinusOne();
    res += this.totalCost[this.currMonthIndex - 1] + this.totalCost[37];
    //Mise a 0 des totaux si la table est vide
    if (res == 0) return 0;
    return res;
  }

  /**
  * Montants: Détermine si l'index du mois correspond au mois en cours de facturation
  */
  isCurrMonth(index: number): boolean {
    if (
      this.currPack == null ||
      index % 12 != (this.currPack.packMonth - 1) % 12
    )
      return false;
    if (index < 12 * (this.currPack.packYear - this.getYear())) return false;
    if (index >= 12 * (1 + this.currPack.packYear - this.getYear()))
      return false;
    return true;
  }

  /**
  * Exports: Lance l'export des commentaires
  */
  exportData() {
    this.spinner = true;
    this._es.exportData().subscribe({
      next: (data) => {
        if (data) {
          const blob: any = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          window.URL.createObjectURL(blob);
          fileSaver.saveAs(
            blob,
            'Export des commentaires - ' +
            new Date().toLocaleDateString().replace('_', '-'),
          );
          this.spinner = false;
        } else {
          this.spinner = false;
          this.openErrorSnackBar('Pas de commentaires à exporter');
        }
      },
      error: (err) => {
        console.error(err);
        this.spinner = false;
        this.openErrorSnackBar('L\'export des commentaires a échoué');
      }
    });
  }


  /**
  * Exports: Exporte les données collectées sous la forme d'un fichier .csv
  */
  downloadFile() {
    this.spinner = true;
    const apps = this.applications;
    const appNames: string[] = [];
    apps.forEach((element) => {
      appNames.push(element.name + '');
    });

    this.jiraImportService
      .getTimedPack(this.exportYear + '', appNames)
      .subscribe({
        next: (data) => {
          const blob: any = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          window.URL.createObjectURL(blob);
          fileSaver.saveAs(
            blob,
            'Données Collectées ' +
            this.exportYear +
            ' - ' +
            this._as.applicationSettings.CDS_name +
            ' - ' +
            new Date().toLocaleDateString().replace('_', '-') +
            ' ' +
            new Date().toLocaleTimeString().replace('_', '-'),
          );
          this.spinner = false;
        },
        error: (err) => {
          console.log(err);
          this.spinner = false;
          this.openErrorSnackBar('L\'export du pack a échoué');
        }
      });
  }


  /**
  * Affichage: Afficher/Cacher les filtres d'application/prestation.
  */
  toggleAppNamesNav() {
    this.isAppNamesNavVisible = !this.isAppNamesNavVisible;
    this.buttonTextFilter = this.isAppNamesNavVisible ? 'Masquer' : 'Afficher';
  }

  openErrorSnackBar(message: string) {
    this.snackbarService.openSnackBar(message, 'error-snack-bar');
  }

  openSuccessSnackBar(message: string) {
    this.snackbarService.openSnackBar(message);
  }


  /**
   * Affichage: Retourne la couleur (Classe CSS) correspondante au statut de demande.
   */
  public readonly statusClassByLabel: Record<string, string> = {
    'Evalué': 'state-blue',
    'Chiffré': 'state-blue',
    'Approuvé': 'state-blue',
    'Engagé': 'state-blue',
    'Analysé': 'state-blue',
    'En attente': 'state-blue',
    'Implémenté': 'state-blue',
    'Testé': 'state-blue',
    'Abandonné': 'state-red',
    'Fermé': 'state-green',
    'Livré': 'state-green',
    'Réceptionné': 'state-green',
    'Accepté': 'state-green',
    'Mise en production': 'state-green',
  };


  /**
   * Remise a zero des filtres
   */
  resetFilters() {
    // Réinitialisez les valeurs des filtres textuels
    this.filter = '';
    this.reffilter = '';
    this.galfilter = '';
    this.desFilter = '';

    // Réinitialisez les valeurs des contrôles de formulaire
    this.displayDemandsStatus.setValue([]);
    this.displayServiceFilter.setValue([]);

    // Mettez à jour la table avec les filtres réinitialisés
    this.getFilteredAndPagedDemandsAndTotals();
  }
}
